import { Map } from 'immutable';

import * as types from './types';


const initialState = new Map({});

const selectedUsersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.TOGGLE_USER_SELECTION: {
      const currentSelection = state.has(`${payload.id}`) ?
        state.delete(`${payload.id}`) :
        state.set(`${payload.id}`, payload);
      return currentSelection;
    }
    case types.CLEAR_USERS_SELECTION:
      return new Map();
    default:
      return state;
  }
};

export default selectedUsersReducer;
